export default __webpack_public_path__ + "static/media/july2024-1.568e9248.jpg";